import { Box, Typography } from '@fullstory/components';
import { APIPropertyLabels } from '@fullstory/library-ui';
import {
  AppDispatch,
  fullstorySelectors,
  getCustomEventPropsLoading,
  getVisibleCustomEventProps,
  SearchMetaAsyncRequestActions,
} from '@fullstory/redux';
import React, { useCallback, useEffect, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

const { getOrgId } = fullstorySelectors;

interface ApiEventBodyProps {
  eventName: string;
}

export const APIEventBody: React.FC<ApiEventBodyProps> = ({ eventName }) => {
  const dispatch = useDispatch<AppDispatch>();
  const orgId = useSelector(getOrgId);
  const customEventPropsLoading = useSelector(getCustomEventPropsLoading);
  const customEventProps = useSelector(getVisibleCustomEventProps);

  const loadConnections = useCallback(() => {
    dispatch(
      SearchMetaAsyncRequestActions.getCustomSchemaConnections(orgId, { events: [eventName] }),
    );
  }, [orgId, eventName, dispatch]);

  useEffect(() => {
    loadConnections();
  }, [loadConnections]);

  const { properties, loading, failed } = useMemo(() => {
    if (!eventName) {
      return {
        properties: [],
        loading: false,
        failed: false,
      };
    }
    const properties = customEventProps.get(eventName);
    const loading = customEventPropsLoading.has(eventName);
    const failed = !properties && !loading;
    return {
      properties: properties ?? [],
      loading,
      failed,
    };
  }, [eventName, customEventPropsLoading, customEventProps]);

  return (
    <div data-component="APIEventBody">
      <Box marginBottom={8}>
        <Typography variant="body3">
          <FormattedMessage defaultMessage="Definition" id="KbSPMS" />
        </Typography>
      </Box>
      <Box marginBottom={12}>
        <Typography variant="body3">
          <FormattedMessage
            defaultMessage="This event was created with the Fullstory API"
            id="u/HDxH"
          />
        </Typography>
      </Box>
      <APIPropertyLabels
        properties={properties}
        loading={loading}
        failed={failed}
        onFailedRetry={loadConnections}
      />
    </div>
  );
};
